import { Grid } from "@mui/material";

import {
  IPrescriptionOrderInformationCardProps,
  PrescriptionOrderInformationCard,
} from "./PrescriptionOtherInformationCard";
import {
  IPrescriptionPatientCardProps,
  PrescriptionPatientCard,
} from "./PrescriptionPatientCard";
import {
  IPrescriptionPrescriberCardProps,
  PrescriptionPrescriberCard,
} from "./PrescriptionPrescriberCard";

export interface IPrescriptionHeaderProps {
  orderInformation?: IPrescriptionOrderInformationCardProps;
  patientInformation?: IPrescriptionPatientCardProps;
  prescriberInformation?: IPrescriptionPrescriberCardProps;
}
export const PrescriptionHeader = ({
  orderInformation,
  patientInformation,
  prescriberInformation,
}: IPrescriptionHeaderProps) => {
  return (
    <Grid container spacing={2}>
      {orderInformation && (
        <Grid size={{ xs: 12, md: 4 }}>
          <PrescriptionOrderInformationCard {...orderInformation} />
        </Grid>
      )}
      {patientInformation && (
        <Grid size={{ xs: 12, md: 4 }}>
          <PrescriptionPatientCard
            {...patientInformation}
            patientId={patientInformation.patientId}
          />
        </Grid>
      )}
      {prescriberInformation && (
        <Grid size={{ xs: 12, md: 4 }}>
          <PrescriptionPrescriberCard {...prescriberInformation} />
        </Grid>
      )}
    </Grid>
  );
};
